import { ellipsis } from 'polished';
import styled from 'styled-components';
import { Typography } from '@clds/typography';
import { STATES } from '../../constants';
import { styleByState } from '../../helpers';
import { wizardTheme } from '../../theme';

const labelColor = styleByState({
  [STATES.DISABLED]: wizardTheme.label.font.color.disabled,
  [STATES.ERROR]: wizardTheme.label.font.color.error,
  [STATES.COMPLETED]: wizardTheme.label.font.color.completed,
  [STATES.ACTIVE]: wizardTheme.label.font.color.active,
  [STATES.INCOMPLETE]: wizardTheme.label.font.color.incomplete,
});

const StepLabel = styled(Typography).attrs((props) => ({ ...props, size: 'sm', weight: 'medium' }))`
  color: ${labelColor};
  padding: 8px 5px 0 5px;
  text-align: center;
  ${ellipsis()}
`;

export default StepLabel;
